import React from 'react';
import { useLanguage } from '../context/LanguageContext';

export default function DataTable({ columns, data, loading, emptyMessage = null, className = '' }) {
  const { t } = useLanguage();

  return (
    <div className="table-wrapper">
      <table className={className}>
        <thead>
          <tr>
            {columns.map((col, i) => (
              <th key={i} style={col.style}>{col.header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td colSpan={columns.length} className="table-loading">{t('common.loadingData')}</td>
            </tr>
          ) : data.length === 0 ? (
            <tr>
              <td colSpan={columns.length} className="table-empty">{emptyMessage || t('common.noData')}</td>
            </tr>
          ) : (
            data.map((row, i) => (
              <tr key={row.id || row.id_emp || row.id_abs || row.id_tc || row.id_hol || i}>
                {columns.map((col, j) => (
                  <td key={j} style={col.style}>
                    {col.render ? col.render(row) : row[col.accessor]}
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
